import {AbstractFormConfig} from "../abstract-form.config";

export class FormSelectConfig extends AbstractFormConfig {

  public selectFirstIfEmpty: boolean = false;
  public showSelectionPrompt: boolean | undefined = undefined;
  public showSelectedNameTooltip: boolean = false;
  // true and false overwrite the default logic
  public showCleanAction: boolean | undefined = undefined;

  constructor(init?: Partial<FormSelectConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
